/**
 * /assistant now opens the Workspace with Study Assistant selected, so existing links
 * (Home, Experiments/MMM/Bid Optimizer "use agent" buttons, Cmd+K) land on the new screen.
 * A ?q= prefill is carried over. The original page (pages/assistant) is kept in the code.
 */
import { Navigate, useSearchParams } from "react-router-dom";

export default function AssistantRedirect() {
  const [params] = useSearchParams();
  const q = params.get("q");
  return <Navigate replace to={`/workspace?agent=assistant${q ? `&q=${encodeURIComponent(q)}` : ""}`} />;
}
